import React from 'react';
import PropTypes from 'prop-types';
import CategoryItem1List from './CategoryItem1List';
import { Message } from '@aperza/ui';
class CategoryMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCategoryList: false,
        };
    }
    onMouseOverCategory() {
        this.setState({
            showCategoryList: true,
        });
    }
    onMouseLeaveCategory(e) {
        let rect = this.categoryMenu.getBoundingClientRect();
        if (e.clientY < rect.bottom) {
            this.setState({
                showCategoryList: false,
            });
        }
    }
    onCloseCategory() {
        this.setState({
            showCategoryList: false,
        });
    }
    render() {
        let { productCategories } = this.props;
        let { showCategoryList } = this.state;
        return (React.createElement("div", { id: "categoryMenu", ref: (categoryMenu) => {
                this.categoryMenu = categoryMenu;
            }, onMouseOver: this.onMouseOverCategory.bind(this), onMouseLeave: this.onMouseLeaveCategory.bind(this) },
            React.createElement("a", { className: "categoryDrawer" },
                React.createElement(Message, { messageId: "navbar.category" }),
                React.createElement("i", { className: "fa fa-caret-down", "aria-hidden": "true" })),
            productCategories && (React.createElement(CategoryItem1List, { show: showCategoryList, productCategories: productCategories, onClose: this.onCloseCategory.bind(this), ...this.props }))));
    }
}
CategoryMenu.propTypes = {
    onClose: PropTypes.func,
    disableMarketplaceBanner: PropTypes.bool,
};
export default CategoryMenu;
